import SDButtonGroup from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/SDButtonGroup'
import PropTypes from 'prop-types'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'

const ClientType = ({
  clientTypeOptions,
  clientType,
  updateClientTypeHandler,
  mandatory,
  errorText,
  label,
  isEditable,
  missing = false,
}) => {
  const finalOptions = []
  clientTypeOptions.forEach(option => {
    finalOptions.push({
      [option]: option,
    })
  })

  return (
    <SDFormControl label={() => <div dangerouslySetInnerHTML={{ __html: mandatory + label }} />} error={errorText}>
      <SDButtonGroup
        disabled={isEditable === false}
        onClickHandler={value => updateClientTypeHandler(value)}
        options={finalOptions}
        selectedValue={clientType}
        missing={missing}
        newTranslations={true}
        translationsPath='subscriptionForm:characteristics_module.contract_type.'
      />
    </SDFormControl>
  )
}

ClientType.propTypes = {
  clientTypeOptions: PropTypes.array,
  clientType: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  updateClientTypeHandler: PropTypes.func,
  mandatory: PropTypes.string,
  errorText: PropTypes.string,
  label: PropTypes.string,
  isEditable: PropTypes.bool,
  missing: PropTypes.bool,
}

export default ClientType
